import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { WebCustomer, CustomerClient } from "src/app/models";
import { CompanyService, CustomerService } from "src/app/services";
import { Subscription } from "rxjs";
import { SessionDataService } from "src/app/services/session-data.service";
import { filter } from "rxjs/operators";


@Component({
  selector: "app-customer-header-info",
  templateUrl: "./customer-header-info.component.html",
  styleUrls: ["./customer-header-info.component.scss"],
})
export class CustomerHeaderInfoComponent implements OnInit, OnDestroy
{
  customerSubscription: Subscription;
  isEmployee: boolean;
  showDate: boolean;
  hasComment: boolean;
  comment: string;
  commentDate: string;
  @Input() customer: WebCustomer;
  @Input() showComment: boolean;

  constructor(
    private sessionDataService: SessionDataService,
    private customerService: CustomerService,
    private companyService: CompanyService,
    private customerClient: CustomerClient
  ) { }

  ngOnInit(): void 
  {
    this.isEmployee = this.sessionDataService.IsEmployee;
    this.customerSubscription = this.customerService.customer.subscribe((customer) =>
    {
      this.customer = customer;
      if (this.customer.AcctStat === 6 || this.customer.AcctStat === 3)
      {
        this.customer.AcctStatColor = "#FF0000";
      }
      if (this.isEmployee && this.companyService.isCustomerCommentAvailable)
      { this.getCustomerComment(); }
    });
  }

  private getCustomerComment(): void 
  {
    this.customerClient
      .getWebCustomerComment(this.customer.BranchCustId)
      .subscribe((webCustomerComment) =>
      {
        this.hasComment = webCustomerComment.CustomerHasComment;
        this.comment = webCustomerComment.CustomerComment1 + " " + webCustomerComment.CustomerComment2;
        if (webCustomerComment.CustomerCommentDate != null)
        {
          this.commentDate = new Date(
            webCustomerComment.CustomerCommentDate
          ).toLocaleDateString();
        }
      });
  }

  public doesCustomerHaveContacts(): boolean
  {
    return !!this.customer?.Contacts?.[0]?.Email?.length;
  }

  ngOnDestroy(): void
  {
    this.customerSubscription.unsubscribe();
  }
}
